module.exports = __webpack_public_path__ + "img/test-banner.c32e3a77.jpg";